import React, {useState, useContext} from 'react'
import _ from 'lodash'
import {IconButton, Checkbox, FormControlLabel, RadioGroup} from '@material-ui/core'
import CircleCheckedFilled from '@material-ui/icons/CheckCircle'
import CreateIcon from '@material-ui/icons/Create'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import CheckIcon from '@material-ui/icons/Check'
import {ReservationCalendarMainContext} from '../../../../context/ReservationCalendarMain'
import {Link} from 'react-router-dom'
import IcalPopup from '../IcalURL/IcalPopup'
import {UserContext} from '../../../../context/User'
import DeleteIcon from '@material-ui/icons/Delete'
import LinkIcon from '../link.png'
import LinkBlackIcon from '../link-black.png'
import StyledRadio from '../ShareableViewPopup/StyledRadio'

const ShareableViewItem = ({
  data,
  onClickEdit,
  onClickView,
  selectedView,
  selectedFilteredView,
  viewData,
  currentView,
  currentColor,
}) => {
  const user = React.useContext(UserContext)
  const {calendarView} = useContext(ReservationCalendarMainContext)
  const [open, handleOpen] = useState(false)

  const mcolor = _.isEmpty(selectedFilteredView) ? data.color : '#ffffff'

  const handleClose = () => {
    handleOpen(false)
  }

  const openModal = () => {
    handleOpen(true)
  }

  return (
    <div>
      <div>
        <div className="sharable-section c-calendar-views__item c-calendar-sharableviews__item ap-flex--align-center height-32">
          <RadioGroup
            row
            aria-label="position"
            name={data.name}
            className="advance-radio-btn sidebar-radio-btn"
            value={currentView}
          >
            <FormControlLabel
              value={data.name}
              control={<StyledRadio color={mcolor} currentColor={currentColor} />}
              label={data.name}
              labelPlacement="end"
              onClick={ev => onClickView(ev, viewData, mcolor)}
            />
          </RadioGroup>

          <div className="ap-flex ap-flex--end">
            <IconButton
              size="small"
              className="ap-icon-button ap-icon-button--square btn-hover btn-hover--hidden"
              style={{marginRight: 8}}
              onClick={e => onClickEdit(e, data)}
            >
              <CreateIcon style={{transform: 'scale(.60)'}} />
            </IconButton>
            <IconButton
              size="small"
              className="ap-icon-button ap-icon-button--square btn-hover btn-hover--hidden"
              style={{marginRight: 8}}
              onClick={openModal}
            >
              <img src={LinkIcon} alt="LinkIcon" className="link-blue" style={{width: 12}} />
              <img
                src={LinkBlackIcon}
                alt="LinkBlackIcon"
                className="link-black"
                style={{width: 12}}
              />
            </IconButton>
          </div>
        </div>
      </div>
      {open && (
        <IcalPopup
          open={open}
          handleClose={handleClose}
          user={!user.details?.isLoading && user}
          id={data?.id}
        />
      )}
    </div>
  )
}

export default ShareableViewItem
